import utils from "core/utils";
import ComponentNames from "../../../../../resources/generated/components.json";
import { ComponentKeys } from "../../../../../core/services/componentService/component-service";

export default {
    process: function(newNodeType, nodeModel, parentNode, predefinedComponentName) {
        if (newNodeType !== utils.ENTITIES.CQ) {
            return;
        }

        if (predefinedComponentName !== ComponentNames.Euclid[ComponentKeys.HumanReadableName]) {
            return;
        }

        // Set the subType to Euclid so it can be identified as a special component
        nodeModel.metaObject.uiconfig = nodeModel.metaObject.uiconfig || {};
        nodeModel.metaObject.uiconfig.subType = ComponentNames.Euclid[ComponentKeys.HumanReadableName];

        // Set the transformation type to euclidTransformation
        nodeModel.metaObject.uiconfig.transformation = "euclidTransformation";

        // Set the component name to Euclid
        nodeModel.metaObject.uiconfig.componentName = ComponentNames.Euclid[ComponentKeys.HumanReadableName];

        // Initialize the config object
        nodeModel.metaObject.uiconfig.config = nodeModel.metaObject.uiconfig.config || {};

        // If there's a parent node (stream), set it as the input
        if (parentNode && parentNode.metaObject.type === utils.ENTITIES.STREAM) {
            nodeModel.metaObject.autoProperties = nodeModel.metaObject.autoProperties || {};
            nodeModel.metaObject.autoProperties.inputStream = parentNode.metaObject.id;
        }
    }
};
